import { render, staticRenderFns } from "./SettingUserModal.vue?vue&type=template&id=16c72c12&"
import script from "./SettingUserModal.vue?vue&type=script&lang=js&"
export * from "./SettingUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports